import React from 'react';
import _ from 'lodash';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useLocation } from 'react-use';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faUserSecret } from '@fortawesome/free-solid-svg-icons';
import Logo from '../logo/Logo';
import { menuSideBarAtom, userAtom, tokenAtom, impersonatorAtom } from '../../../atoms/Atoms';
import LanguagePicker from '../language-picker/LanguagePicker';
import envConfig from '../../../envConfig';
import { stopImpersonation } from '../../../impersonation';

function Header() {
  const { t } = useTranslation();
  const location = useLocation();
  const [user, setUser] = useRecoilState(userAtom);
  const setToken = useSetRecoilState(tokenAtom);
  const [impersonator, setImpersonator] = useRecoilState(impersonatorAtom);
  const [isMenuOpen, setIsMenuOpen] = useRecoilState(menuSideBarAtom);
  const hideMenu = location.pathname !== '/' ? _.filter(envConfig.HideMenuLocations, (l) =>
    location.pathname.startsWith(l)).length >= 1 : true;
  const showLogo = _.filter(envConfig.HideHeaderLogo, (l) =>
    location.pathname.startsWith(l)).length >= 1;

  function onStopImpersonating() {
    const adminProfile = stopImpersonation();
    setImpersonator(null);
    if (adminProfile) {
      setToken(window.localStorage.getItem(`${envConfig.StoragePrefix}-token`));
      setUser(adminProfile);
      window.location = '/users';
    } else {
      // Nothing left to restore, so drop the session rather than leave the
      // admin stranded in the impersonated account.
      window.localStorage.removeItem(`${envConfig.StoragePrefix}-user`);
      window.localStorage.removeItem(`${envConfig.StoragePrefix}-token`);
      setToken(null);
      setUser(null);
      window.location = '/';
    }
  }

  return (
    <>
      {impersonator && (
        <div className="sticky top-0 z-40 flex w-full items-center gap-2 bg-amber-500 px-4 py-2 text-sm text-white md:px-6">
          <FontAwesomeIcon icon={faUserSecret} />
          <span className="truncate">
            {t('impersonating')}: <strong>{user?.completeName || user?.email}</strong>
          </span>
          <button
            type="button"
            onClick={onStopImpersonating}
            className="ml-auto shrink-0 rounded-md bg-white/20 px-3 py-1 font-medium transition-colors duration-200 ease-in-out hover:bg-white/30 ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
          >
            {t('stop_impersonating')}
          </button>
        </div>
      )}
      <header className="sticky top-0 z-30 h-16 shrink-0 border-b border-line bg-header shadow-header">
        <div className="flex h-full w-full items-center gap-2 px-4 md:px-6">
          {showLogo && (
            <Logo
              parentClassName="flex items-center transition-opacity duration-200 ease-in-out hover:opacity-75"
              className="w-32 md:w-40"
            />
          )}
          <div className="ml-auto flex items-center gap-1">
            <LanguagePicker className="hidden md:block" />
            {!hideMenu && (
              <button
                aria-label="sidemenu"
                type="button"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="md:hidden flex h-10 w-10 items-center justify-center rounded-lg text-lg text-headerText transition-colors duration-200 ease-in-out hover:bg-gold-50 ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400"
              >
                <FontAwesomeIcon icon={faBars} />
              </button>
            )}
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
